import { XMarkIcon } from "@heroicons/react/16/solid";

const TagDisplay = ({ tags, onRemoveTag }) => {
  if (!tags || tags.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-2 mt-2">
      {tags.map((tag) => (
        <div
          key={tag.id}
          className="inline-flex items-center gap-1 px-2 py-1 text-sm bg-gray-100 text-gray-800 rounded-md"
        >
          <span>{tag.label}</span>
          <button
            type="button"
            onClick={() => onRemoveTag(tag.id)}
            className="text-gray-500 hover:text-gray-700"
          >
            <XMarkIcon className="w-3 h-3" />
          </button>
        </div>
      ))}
    </div>
  );
};

export default TagDisplay;
